import type { Theme } from '@mui/material/styles';

/**
 * styled 템플릿 콜백에 커스텀 props 타입을 부여합니다.
 * shouldForwardProp와 함께 쓰면 DOM 경고를 줄일 수 있습니다.
 */
export type StyledThemeProps<T extends Record<string, unknown> = Record<string, never>> = {
  theme: Theme;
} & T;

/** MUI styled 커스텀 prop이 DOM으로 전달되지 않도록 필터합니다. */
export const createShouldForwardProp =
  (...blockedProps: string[]) =>
  (prop: string): boolean =>
    !blockedProps.includes(prop);

export const sidebarStyleCustomProps = [
  'sidebarOpen',
  'headerHeight',
  'parentState',
  'childrenState',
  'linkable',
  'useAction',
  'mobileState',
  'placement',
  'sarafarmBrandedSidebar',
  'isPreview',
] as const;

export const shouldForwardSidebarStyleProp = createShouldForwardProp(
  ...sidebarStyleCustomProps,
);
